<template>
  <div class="profile-data-in-modal">
    <v-layout
      row
      align-center
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense font-weight-medium black--text">{{ transactionPartyType | optionName(transactionPartyOptions) }}</v-subheader>
      </v-flex>

      <v-flex xs8>
        <div
          :id="`review-${transactionPartyType}-name`"
          class="font-weight-medium"
        >{{ profile.name || profile.id }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Register number</v-subheader>
      </v-flex>

      <v-flex xs8>
        <div :id="`review-${transactionPartyType}-code`">{{ profile.regNumber }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Address</v-subheader>
      </v-flex>

      <v-flex xs8>
        <div :id="`review-${transactionPartyType}-address`">{{ profile.address }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Country</v-subheader>
      </v-flex>

      <v-flex xs8>
        <div :id="`review-${transactionPartyType}-country`">{{ getCountryName(profile.country) }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Account Nr.</v-subheader>
      </v-flex>

      <v-flex xs8>
        <span :id="`review-${transactionPartyType}-account-id`">{{ selectedAccount.accountId }}</span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  // Models
  import Transaction from '@/models/Transaction'
  import Account from '@/models/Account'

  // Mixins
  import countries from '@/mixins/countries'

  export default {
    name: 'ProfileDataInModal',
    mixins: [countries],
    props: {
      transactionPartyType: {
        required: true,
        type: String
      },
      profile: {
        required: true,
        type: Object
      },
      selectedAccount: {
        required: true,
        type: Account
      }
    },
    computed: {
      transactionPartyOptions () {
        return Transaction.partyOptions
      }
    }
  }
</script>

<style lang="scss">
  .profile-data-in-modal {
    .layout.row {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  }
</style>
